/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable react/self-closing-comp */
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import fluxQuerys from "../analyticsCustomSearch/AnalyticsFluxQuery";
import helpers from "../AnalyticsHelpers";
import Loading from "../Loading";
import CardMetric from "./CardMetric";

function LastStateIndividualApartment({
  individualApartmentId,
  individualApartmentName,
  projectTimeZone,
  metricsConfig,
  darkMode,
  t,
}) {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [warn, setWarn] = useState(null);
  const lastAutoFetchKeyRef = useRef(null);
  const enabledMetrics = useMemo(() => helpers.getEnabledMetrics(metricsConfig), [metricsConfig]);
  const enabledMetricKeys = useMemo(
    () => enabledMetrics.map((metric) => metric.key),
    [enabledMetrics]
  );
  const queryKey = useMemo(
    () => `${individualApartmentId || ""}::${enabledMetricKeys.join(",")}`,
    [individualApartmentId, enabledMetricKeys]
  );

  const fetchData = useCallback(
    (options = {}) => {
      const { force = false } = options;

      if (!individualApartmentId || enabledMetricKeys.length === 0) {
        setRows([]);
        setLoading(false);
        if (!force) lastAutoFetchKeyRef.current = null;
        return;
      }

      if (!force && lastAutoFetchKeyRef.current === queryKey) return;
      if (!force) lastAutoFetchKeyRef.current = queryKey;

      setLoading(true);
      setWarn(null);

      const lastStateIndividualApartmentQueryFlux = fluxQuerys.individualLastStateFlux(
        individualApartmentId,
        enabledMetricKeys
      );

      dispatch({
        type: "MAKE_QUERY",
        payload: {
          source: "dev",
          apartmentId: individualApartmentId,
          flux: lastStateIndividualApartmentQueryFlux,
          cb: (res) => {
            try {
              const devRows = helpers.extractRows(res);

              const valuesToShow = {};

              let responseTime = null;

              devRows.forEach((r) => {
                const meansurement = r?._measurement;

                let value = r?._value;

                if (!meansurement) return;

                if (meansurement === "presence") value = Number(value) > 0 ? 1 : 0;

                const num = Number(value);

                valuesToShow[meansurement] = Number.isFinite(num) ? num : undefined;

                responseTime = r?._time ? new Date(r._time).valueOf() : NaN;
              });

              const label = individualApartmentName;

              const row = {
                apartmentId: individualApartmentId,
                apartment: label,
                updatedAt: responseTime,
              };

              enabledMetrics.forEach((meansurement) => {
                row[meansurement?.key] =
                  valuesToShow[meansurement?.key] !== undefined &&
                  valuesToShow[meansurement?.key] !== null
                    ? valuesToShow[meansurement?.key]
                    : undefined;
              });

              const hasAny = enabledMetrics.some(
                (meansurement) =>
                  row[meansurement?.key] !== undefined && row[meansurement?.key] !== null
              );

              setRows(hasAny ? [row] : []);
            } catch (e) {
              setWarn(t("influxErrorRequest"));
            } finally {
              setLoading(false);
            }
          },
        },
      });
    },
    [
      dispatch,
      enabledMetricKeys,
      enabledMetrics,
      individualApartmentId,
      individualApartmentName,
      queryKey,
      t,
    ]
  );

  useEffect(() => {
    const cleanup = fetchData();
    return cleanup;
  }, [fetchData]);

  const handleReload = () => fetchData({ force: true });

  const renderCard = () => {
    if (enabledMetricKeys.length === 0) {
      return (
        <MDBox
          style={{
            border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
            background: darkMode ? "#26304b" : "#ffffff",
            borderRadius: 14,
            padding: 16,
          }}
        >
          {t("noMetricsConfiguredToShow")}
        </MDBox>
      );
    }

    const dataToShow = rows[0];

    const apartmentName = dataToShow?.apartment;
    const updatedAt = dataToShow?.updatedAt;
    const dateToShow = helpers.formatAnalyticsDate({
      ts: updatedAt,
      queryPeriod: "hourly",
      timeZone: projectTimeZone,
    });

    if (loading) {
      return <Loading darkMode={darkMode} t={t} />;
    }

    if (!dataToShow) {
      return (
        <MDBox
          style={{
            border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
            background: darkMode ? "#26304b" : "#ffffff",
            borderRadius: 14,
            padding: 16,
          }}
        >
          {t("noPossibleShowData")}
        </MDBox>
      );
    }

    return (
      <MDBox
        style={{
          border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
          background: darkMode ? "#26304b" : "#ffffff",
          borderRadius: 16,
          padding: 18,
          boxShadow: darkMode ? "none" : "0 6px 18px rgba(12,46,84,.06)",
          width: "100%",
        }}
      >
        {/* Header */}
        <MDBox
          style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}
        >
          <MDBox style={{ fontWeight: 800, fontSize: 18, color: darkMode ? "#f8fafc" : "#0f172a" }}>
            {apartmentName}
          </MDBox>

          <MDBox
            style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6 }}
          >
            <MDButton
              onClick={handleReload}
              style={{
                border: darkMode ? "1px solid #1a2035" : "1px solid #e5e7eb",
                background: darkMode ? "#1a2035" : "#ffffff",
                borderRadius: 10,
                padding: "6px 12px",
                fontSize: 13,
                color: darkMode ? "#f8fafc" : "#0f172a",
              }}
            >
              {loading ? t("updated") : t("reload")}
            </MDButton>

            {updatedAt && (
              <MDTypography style={{ fontSize: 12, color: darkMode ? "#f8fafc" : "#0f172a" }}>
                {`${t("lastData")}: ${dateToShow}`}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>

        {/* Grid de métricas */}
        <MDBox
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: 12,
            marginTop: 14,
          }}
        >
          {enabledMetrics.map((apartmentMeasurement) => {
            const measurementKey = apartmentMeasurement?.key;
            const formatedValue = apartmentMeasurement?.formatedValueToString(
              dataToShow[measurementKey]
            );

            if (!formatedValue) return null;

            const effectiveSuffix = helpers.getMetricSuffix(measurementKey, metricsConfig);
            const metricLabel = helpers.getMetricDisplayLabel({
              metricKey: measurementKey,
              metricsConfig,
              t,
            });

            return (
              <CardMetric
                measurementKey={measurementKey}
                metricLabel={metricLabel}
                effectiveSuffix={effectiveSuffix}
                formatedValue={formatedValue}
                darkMode={darkMode}
              />
            );
          })}
        </MDBox>
      </MDBox>
    );
  };

  return (
    <MDBox>
      {warn ? (
        <MDBox
          style={{
            background: darkMode ? "#1a2035" : "#ffffff",
            color: darkMode ? "#ffffff" : "#1a2035",
            padding: "8px 12px",
            borderRadius: 8,
            marginBottom: 12,
          }}
        >
          {warn}
        </MDBox>
      ) : null}
      {renderCard()}
    </MDBox>
  );
}

LastStateIndividualApartment.defaultProps = {
  individualApartmentId: "",
  individualApartmentName: "",
  projectTimeZone: "UTC",
  metricsConfig: {},
  darkMode: false,
};

LastStateIndividualApartment.propTypes = {
  individualApartmentId: PropTypes.string,
  individualApartmentName: PropTypes.string,
  projectTimeZone: PropTypes.string,
  metricsConfig: PropTypes.object,
  darkMode: PropTypes.bool,
};

export default LastStateIndividualApartment;
